package com.happyukrainian.revision.kweb.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.happyukrainian.revision.kweb.config.FlipContainerStyle
import com.varabyte.kobweb.compose.css.AnimationIterationCount
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.animation
import com.varabyte.kobweb.compose.ui.modifiers.rotateY
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.animation.toAnimation
import com.varabyte.kobweb.silk.style.toModifier
import flashcards.FlashCard
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.AnimationFillMode
import org.jetbrains.compose.web.css.AnimationTimingFunction
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.s

val FlipOutAnimation =
    Keyframes {
        from { Modifier.rotateY(0.deg) }
        to { Modifier.rotateY(90.deg) }
    }

val FlipInAnimation =
    Keyframes {
        from { Modifier.rotateY((-90).deg) }
        to { Modifier.rotateY(0.deg) }
    }

val FlipBackInAnimation =
    Keyframes {
        from { Modifier.rotateY(90.deg) }
        to { Modifier.rotateY(0.deg) }
    }

val FlipBackOutAnimation =
    Keyframes {
        from { Modifier.rotateY(0.deg) }
        to { Modifier.rotateY((-90).deg) }
    }

@Composable
fun FlashcardComponent(
    flashCard: FlashCard,
    compact: Boolean,
    showingQuestion: Boolean,
    toggleSide: (FlashCard) -> Unit,
    modifier: Modifier = Modifier,
) {
    var flipping by remember { mutableStateOf(false) }
    val coroutineScope = rememberCoroutineScope()
    val flippingIn =
        Modifier
            .animation(
                FlipOutAnimation.toAnimation(
                    timingFunction = AnimationTimingFunction.EaseIn,
                    duration = 0.3.s,
                    iterationCount = AnimationIterationCount.of(1),
                    fillMode = AnimationFillMode.Forwards,
                ),
            )

    val flippingBackIn =
        Modifier
            .animation(
                FlipBackInAnimation.toAnimation(
                    timingFunction = AnimationTimingFunction.EaseOut,
                    duration = 0.3.s,
                    iterationCount = AnimationIterationCount.of(1),
                    fillMode = AnimationFillMode.Forwards,
                ),
            )

    val flippingOut =
        Modifier.animation(
            FlipInAnimation.toAnimation(
                timingFunction = AnimationTimingFunction.EaseOut,
                duration = 0.3.s,
                iterationCount = AnimationIterationCount.of(1),
                fillMode = AnimationFillMode.Forwards,
            ),
        )

    val flippingBackOut =
        Modifier.animation(
            FlipBackOutAnimation.toAnimation(
                timingFunction = AnimationTimingFunction.EaseIn,
                duration = 0.3.s,
                iterationCount = AnimationIterationCount.of(1),
                fillMode = AnimationFillMode.Forwards,
            ),
        )

    var questionAnimation by remember(flashCard) { mutableStateOf<Modifier>(Modifier) }
    var answerAnimation by remember(flashCard) { mutableStateOf<Modifier>(Modifier) }

    Box(modifier = modifier.width(100.percent).then(FlipContainerStyle.toModifier())) {
        if (showingQuestion) {
            Box(
                modifier = Modifier.width(100.percent).then(questionAnimation),
            ) {
                FlippableFlashCard(
                    text = flashCard.questionText,
                    compact = compact,
                    onTap = {
                        if (!flipping) {
                            coroutineScope.launch {
                                flipping = true
                                questionAnimation = flippingIn
                                delay(300)
                                toggleSide(flashCard)
                                answerAnimation = flippingOut
                                delay(300)
                                answerAnimation = Modifier
                                flipping = false
                            }
                        }
                    },
                    configuration = FlashCardConfiguration.Question,
                )
            }
        }

        if (!showingQuestion) {
            Box(
                modifier = Modifier.width(100.percent).then(answerAnimation),
            ) {
                FlippableFlashCard(
                    text = flashCard.answerText,
                    compact = compact,
                    onTap = {
                        if (!flipping) {
                            coroutineScope.launch {
                                flipping = true
                                answerAnimation = flippingBackOut
                                delay(300)
                                toggleSide(flashCard)
                                questionAnimation = flippingBackIn
                                delay(300)
                                questionAnimation = Modifier
                                flipping = false
                            }
                        }
                    },
                    configuration = FlashCardConfiguration.Answer,
                )
            }
        }
    }
}
